var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplayMediumCustomCar = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m67.077 33.412-4.49-14.932a7.936 7.936 0 0 0-7.628-5.68H24.933c-3.57 0-6.654 2.272-7.628 5.68l-4.49 14.932C10.002 34.656 8 37.469 8 40.715v15.96a3.994 3.994 0 0 0 4.003 4.003v4.004a3.994 3.994 0 0 0 4.004 4.003h4.003a3.994 3.994 0 0 0 4.004-4.003v-4.004h31.972v4.004a3.994 3.994 0 0 0 4.004 4.003h4.003a3.994 3.994 0 0 0 4.004-4.003v-4.004A3.994 3.994 0 0 0 72 56.675v-15.96c-.108-3.3-2.11-6.113-4.923-7.303zm-42.144-12.66H54.96l3.57 12.01H21.31l3.624-12.01zm-.974 29.972a3.994 3.994 0 0 1-4.003-4.003 3.994 3.994 0 0 1 4.003-4.004 3.994 3.994 0 0 1 4.004 4.004 3.994 3.994 0 0 1-4.004 4.003zm31.973 0a3.994 3.994 0 0 1-4.003-4.003 3.994 3.994 0 0 1 4.003-4.004 3.994 3.994 0 0 1 4.004 4.004c-.054 2.218-1.84 4.003-4.004 4.003z",
    fill: "#F2AE18",
    fillRule: "nonzero"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplayMediumCustomCar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-medium-custom-car.b8b70346fb1c701c4797955b8375312d.svg";